<div class="entity-title-container">
	@if (entityType) {
		<mat-icon [svgIcon]="entityType()" />
	}

	<div class="title">{{ name() }}</div>
</div>
